import { createContext, useState, useContext } from "react";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { useNotification } from "./NotificationProvider";
const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(false);
  const [token, setToken] = useLocalStorage("token", null);
  const notify = useNotification();
  const logout = (showToast) => {
    setToken(null);
    if (showToast) {
      notify({
        type: "info",
        message: "Logout Success",
        description: "User Logged Out Successfully",
      });
    }
  };
  return (
    <UserContext.Provider value={{ user, setUser, setToken, token, logout }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook for accessing the UserContext
export const useUser = () => useContext(UserContext);
